import React from "react";

export default function TermsAndConditionsPG() {
  return (


  <>
  
    <section
      className="page-title"
      style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
    >
      <div className="auto-container">
        <h1>Terms and Conditions </h1>
       
      </div>
    </section>

    <div className="ppg-root">
      {/* HERO */}
      <section className="ppg-hero">
        <div className="ppg-container">
          <h1 className="ppg-title">Terms and Conditions</h1>
          <span className="ppg-title-underline" />
        </div>
      </section>

      {/* GRID */}
      <section className="ppg-container pgp-grid">
        {/* LEFT: MAIN CONTENT */}
        <article className="ppg-main">
          <h2 className="ppg-h2">Terms and Conditions at Shree Swami Samarth PG:</h2>

          <h3 className="ppg-h3">Lease Agreement:</h3>
          <p className="ppg-p">
            All residents at Shree Swami Samarth PG are required to sign a lease agreement. This
            agreement outlines the terms and conditions of occupancy, including the duration of
            stay, rent amount, and any specific regulations related to the use of the premises. It
            is imperative that residents thoroughly review and understand the lease agreement
            before signing.
          </p>

          <h3 className="ppg-h3">Payment Terms:</h3>
          <p className="ppg-p">
            Rent payments are due on the specified date as outlined in the lease agreement.
            Residents are required to make payments promptly to avoid any late fees or penalties.
            Accepted payment methods, including online payment options, will be communicated to
            residents upon signing the lease.
          </p>

          <h3 className="ppg-h3">Security Deposit:</h3>
          <p className="ppg-p">
            A security deposit is collected from each resident upon move-in. This deposit is
            refundable, subject to the satisfactory condition of the living space upon vacating.
            Deductions may be made for any damages beyond normal wear and tear.
          </p>

          <h3 className="ppg-h3">Utilities and Additional Charges:</h3>
          <p className="ppg-p">
            Residents are responsible for utility payments as specified in the lease agreement.
            Any additional charges, such as fines for rule violations, will be communicated
            transparently, and residents are expected to settle these promptly.
          </p>

          <h3 className="ppg-h3">Lease Renewal and Termination:</h3>
          <p className="ppg-p">
            Residents interested in renewing their lease must notify the management within the
            stipulated timeframe. Termination of the lease requires adherence to the specified
            notice period. Early termination may be subject to penalties as outlined in the lease
            agreement.
          </p>

          <h3 className="ppg-h3">Maintenance and Repairs:</h3>
          <p className="ppg-p">
            Residents are expected to promptly report any maintenance issues or repairs needed in
            their living spaces. The management will address reported issues in a timely manner.
            Residents are responsible for any damages caused by neglect or intentional actions.
          </p>

          <h3 className="ppg-h3">Community Guidelines:</h3>
          <p className="ppg-p">
            Residents must adhere to the community guidelines and rules set forth by Shree Swami
            Samarth PG. These guidelines are designed to create a harmonious living environment
            and ensure the well-being of all residents. Violation of community guidelines may
            result in warnings or fines.
          </p>

          <h3 className="ppg-h3">Guest Policy:</h3>
          <p className="ppg-p">
            Residents are permitted to have guests, provided they adhere to the guest policy
            outlined in the terms and conditions. Overnight guests require prior notification to
            the management, and residents are responsible for their guests' conduct.
          </p>

          <h3 className="ppg-h3">Entry and Access:</h3>
          <p className="ppg-p">
            The management reserves the right to enter individual living spaces for maintenance,
            repairs, inspections, or emergency situations. Residents will be provided with
            reasonable notice, except in cases of emergencies.
          </p>

          <h3 className="ppg-h3">Compliance with Local Laws:</h3>
          <p className="ppg-p">
            Residents are expected to comply with all local laws and regulations. Engaging in any
            illegal activities within the premises is strictly prohibited and may result in
            immediate eviction.
          </p>

          <h3 className="ppg-h3">Notices and Communication:</h3>
          <p className="ppg-p">
            Official notices and communication from the management will be conveyed through the
            provided contact information. Residents are responsible for regularly checking their
            emails or other specified communication channels for important updates.
          </p>

          <p className="ppg-p">
            Understanding and adherence to these terms and conditions are crucial for maintaining
            a positive and respectful community living experience at Shree Swami Samarth PG. The
            terms are designed to ensure clarity, fairness, and the well-being of all residents.
            Residents with any questions or concerns regarding the terms and conditions are
            encouraged to reach out to the management for clarification.
          </p>

          <div className="ppg-note">
            <p className="ppg-p tight"><strong>Best Regards,</strong></p>
            <p className="ppg-p tight"><strong>Shree Swami Samarth PG Management Team</strong></p>
            <p className="ppg-p tight"><strong>Mo.No-</strong> +91 9209169761</p>
            <p className="ppg-p tight">
              <strong>Address-</strong> Shree Swami Samarth PG, 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
            </p>
          </div>
        </article>

        {/* RIGHT: CONTACT SIDEBAR */}
        <aside className="ppg-aside" aria-label="Get in touch">
          <div className="ppg-contact">
            <h4>GET IN TOUCH</h4>
            <ul>
              <li>
                <span className="lbl">Phone:</span>
                <span className="val">+91 9209169761</span>
              </li>
              <li>
                <span className="lbl">Whatsapp:</span>
                <span className="val">+91 9096665072</span>
              </li>
              <li>
                <span className="lbl">Address:</span>
                <span className="val">
                  Shree Swami Samarth,<br />
                   PG M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057

                </span>
              </li>
            </ul>
          </div>
        </aside>
      </section>

      {/* Scoped CSS to match your Privacy Policy page style */}
      <style>{`
        :root { --brand:#EAC2A4; --ink:#0f172a; --muted:#4b5563; --bg:#faf7f4; }
        .ppg-root{ background:#fff; color:var(--ink); }
        .ppg-container{ width:min(1200px,92%); margin:0 auto; }
        .ppg-hero{ background:var(--bg); border-bottom:1px solid #eee; }
        .ppg-title{ font-size:2rem; margin:1.2rem 0 .5rem; letter-spacing:.2px; }
        .ppg-title-underline{ display:block; width:90px; height:4px; background:var(--brand); border-radius:999px; margin-bottom:1rem; }

        .pgp-grid{ display:grid; grid-template-columns:2fr 1fr; gap:2rem; padding:1.5rem 0 2.5rem; }
        .ppg-main{ min-width:0; }
        .ppg-h2{ font-size:1.15rem; font-weight:700; color:#111827; margin:.25rem 0 1rem; }
        .ppg-h3{ font-size:1.05rem; font-weight:700; color:#111827; margin:1.75rem 0 .5rem; }
        .ppg-p{ color:var(--muted); font-size:1rem; line-height:1.9; margin:.35rem 0 1rem; }
        .ppg-p.tight{ margin:.2rem 0; }

        .ppg-note{ border:1px solid var(--brand); background:#fff9f5; border-radius:12px; padding:1rem; margin-top:1.25rem; }

        .ppg-aside{ min-width:260px; }
        .ppg-contact{
          position:sticky; top:88px;
          background:var(--brand); color:#231f20;
          border-radius:12px; padding:1.25rem;
          box-shadow:0 10px 30px rgba(0,0,0,.08) inset, 0 6px 24px rgba(0,0,0,.06);
        }
        .ppg-contact h4{ margin:0 0 .8rem; font-size:1.1rem; letter-spacing:.5px; }
        .ppg-contact ul{ list-style:none; margin:0; padding:0; display:grid; gap:.9rem; }
        .ppg-contact .lbl{ display:block; font-weight:800; margin-bottom:.1rem; }
        .ppg-contact .val{ display:block; }

        @media (max-width:1024px){ .pgp-grid{ grid-template-columns:1.6fr 1fr; } }
        @media (max-width:840px){
          .pgp-grid{ grid-template-columns:1fr; }
          .ppg-aside{ order:-1; }
          .ppg-contact{ position:relative; top:0; margin-bottom:1rem; }
        }
      `}</style>
    </div>
  </>
  );
}
